import Add from "@mui/icons-material/Add";
import Delete from "@mui/icons-material/Delete";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import React from "react";
import { useFieldArray } from "react-hook-form";
import FormSelectField from "../../Common/FormSelectField";
import FormTextField from "../../Common/FormTextField";
import ConfigExtractionQueryDialog from "../../useDialogs/ConfigExtractionQueryTypeDialog";
import { useDialogs } from "../../useDialogs/useDialogs";
import {
  defaultAggregateExtractionQuery,
  defaultComputedExtractionQuery,
  defaultLLMExtractionQuery,
  defaultPredefinedExtractionQuery,
  defaultRegexExtractionQuery,
} from "./ConfigDefault";
import ConfigExtractionQuery from "./ConfigExtractionQuery";
import {
  useConfigModeContext,
  useFormConfigContext,
} from "./ConfigFormContext";

interface ConfigExtractionRoutedQueryProps {
  index: number;
  removeRouted: Function;
  routes: string[];
}

const ConfigExtractionRoutedQuery: React.FC<
  ConfigExtractionRoutedQueryProps
> = ({ index, removeRouted, routes }) => {
  const { control } = useFormConfigContext();
  const dialogs = useDialogs();
  const { isReadOnly } = useConfigModeContext();
  const {
    fields: queries,
    append: addQuery,
    remove: removeQuery,
  } = useFieldArray({
    control,
    name: `config.extraction.queries.${index}.queries`,
  });

  const addLLMQuery = () => addQuery(defaultLLMExtractionQuery());
  const addRegexQuery = () => addQuery(defaultRegexExtractionQuery());
  const addPredefinedQuery = () => addQuery(defaultPredefinedExtractionQuery());
  const addComputedQuery = () => addQuery(defaultComputedExtractionQuery());
  const addAggregateQuery = () => addQuery(defaultAggregateExtractionQuery());

  return (
    <Card className="m-1 overflow-visible">
      <CardContent>
        <Stack rowGap={2}>
          <div className="flex justify-between items-center">
            <Typography className="text-xl font-semibold">
              Groupe d'extractions
            </Typography>
            {!isReadOnly && (
              <div className="flex">
                <Button
                  variant="contained"
                  onClick={() =>
                    dialogs.open(ConfigExtractionQueryDialog, {
                      addLLMQuery: addLLMQuery,
                      addRegexQuery: addRegexQuery,
                      addPredefinedQuery: addPredefinedQuery,
                      addComputedQuery: addComputedQuery,
                      addAggregateQuery: addAggregateQuery,
                    })
                  }
                >
                  <Add />
                  Extraction
                </Button>
                <Button color="error" onClick={() => removeRouted()}>
                  <Delete color="error" />
                </Button>
              </div>
            )}
          </div>

          <FormSelectField
            size="small"
            control={control}
            name={`config.extraction.queries.${index}.routes.0`}
            options={routes}
            label="Classification"
          />
          <FormTextField
            size="small"
            multiline
            control={control}
            name={`config.extraction.queries.${index}.params.context_description`}
            label="Description"
          />
          {queries?.map((q, queryIndex) => (
            <ConfigExtractionQuery
              key={queryIndex}
              index={index}
              groupIndex={queryIndex}
              removeQuery={() => removeQuery(index)}
            />
          ))}
        </Stack>
      </CardContent>
    </Card>
  );
};
export default ConfigExtractionRoutedQuery;
